import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { KbInfo } from '@medindex-webapi';
import { HelixBookUtils } from '../utils/helix-book-utils';

@Pipe({
  name: 'kbInfo',
})
export class KbInfoPipe implements PipeTransform {
  constructor(private sanitized: DomSanitizer) {}

  transform(info: KbInfo): SafeHtml {
    let markup = `<div class="html-markup">
      ${info.shortInfo ?? ''}
      ${info.info ?? ''}
      ${info.interpretationInfo ?? ''}
      </div>
      <div class="html-markup">
      ${info.additionalInfo ?? ''}
      </div>`.replaceAll(/(id=.*")/g, '');

    let i = 0;

    HelixBookUtils.getItemSubjects(markup).forEach((anchor) => {
      const regex = new RegExp(
        `(<strong\\s*>)${anchor.replaceAll('?', '\\?')}`,
        'g'
      );
      if (regex.test(markup)) {
        markup = markup.replaceAll(
          regex,
          `<strong id='subj${i}' class="subj-header">${anchor}`
        );
        i++;
      }
    });

    return this.sanitized.bypassSecurityTrustHtml(markup);
  }
}
